import { Component, Input, OnInit } from "@angular/core";
import { ResultListSearch, Brand, Type } from "@models/interfaces";
import { SearchService } from "@shared/services/search.service";
import { Router } from "@angular/router";
import { LoaderService } from "@shared/services/loader.service";
import { BrandService } from "@shared/services/brand.service";
import { TypeService } from "@shared/services/type.service";
import { takeUntil } from "rxjs/operators";
import { Subject } from "rxjs";

@Component({
    selector: "mv-lists-home-wedding-list-search",
    styleUrls: ["./listSearch.component.scss"],
    templateUrl: "./listSearch.component.html",
})
export class ListSearchComponent implements OnInit {
    public searchInput: string;
    public datasSearch: ResultListSearch[] = [];
    public firstShearch: boolean = true;
    public brand: Brand;
    public type: Type;
    @Input() isOpen: boolean = false;
    private readonly destroy$: Subject<boolean> = new Subject<boolean>();

    constructor(
        private searchService: SearchService,
        private router: Router,
        private loaderService: LoaderService,
        private typeService: TypeService,
        private brandService: BrandService,
    ) {}

    ngOnInit() {
        this.brandService.brand$.pipe(takeUntil(this.destroy$)).subscribe((brandVal) => {
            this.brand = brandVal;
        });

        this.typeService.type$.pipe(takeUntil(this.destroy$)).subscribe((typeVal) => {
            this.type = typeVal;
        });
    }
    public searchList(): void {
        this.firstShearch = false;
        this.loaderService.startLoader();
        this.searchService.searchList(this.searchInput).subscribe((datas: ResultListSearch[]) => {
            this.datasSearch = [];
            if (datas != null) {
                this.datasSearch = datas;
            }
            this.loaderService.stopLoader();
        });
    }
}
